import { createContext, useContext } from 'react';
/**
 * A utility function for creating typed contexts that don't need a default value.
 * @returns a tuple where the first argument is a useCtx hook and the second is the provider.
 */
export function createCtx() {
    var ctx = createContext(undefined);
    var useCtx = function () {
        var c = useContext(ctx);
        if (c === undefined)
            throw new Error('useCtx must be inside a Provider with a value');
        return c;
    };
    return [useCtx, ctx.Provider, ctx];
}
